import {DatePickerSeeker, DateRangePickerSeeker, GridSeeker, RadioGroupSeeker} from "ui-seeker/core"
import { DateRangePicker } from 'rsuite'
import React from "react"
import {useContextSelector} from "use-context-selector";
import {AppCalendarEventsContext} from "../../Providers";


const radioGroupData = [
    { value: "1Day", label: "1 day" },
    { value: "moreThanOneDay", label: "More than one day" }
];

const { beforeToday } = DateRangePicker;

export default function DateSelection({ updateForm }) {
    const { dateType, datePicker, dateRange } = useContextSelector(AppCalendarEventsContext, ({ state }) => state.formData)
    const dateRangeConfig = {
        id: "dateRange",
        value: dateRange,
        onChange: (e) => updateForm({ dateRange: e }),
        disabledDate: d => beforeToday()(d)
    }

    return <>
            <GridSeeker size={12} className="date-type">
                <RadioGroupSeeker dataRadioGroup={radioGroupData} formLabel="Date" defaultValue={dateType} onChange={e => updateForm({ dateType: e.target.value, datePicker: null, dateRange: [] })} />
            </GridSeeker>
            <GridSeeker size={12} className="selector-date">
                {dateType === '1Day' && <DatePickerSeeker id="datePicker" value={datePicker} onChange={(e) => updateForm({ datePicker: e })} />}
                {dateType === 'moreThanOneDay' && <DateRangePickerSeeker {...dateRangeConfig} />}
            </GridSeeker>
    </>
}